import React from 'react'
import RiskSlider from '../../../Home/components/RiskSlider/RiskSlider';

export default function TaskStatusWidget() {
  return (
    <div className="widget">
      {/* header */}
      <div className="d-flex align-items-center justify-content-between">
        <h3 className="widget-title">Task status</h3>
      </div>
      {/* Header */}

      <h6 className="text-gray-400 fw-300">
        <small className="text-gray-500 ml-1">Description</small>
      </h6>

      <div className="row mt-3 justify-content-between align-items-center">
        {/*  */}
        <div className="col-6">
          <div className="row">
            <div className="col">
              <small className="text-gray-500">Planning</small>
              <h2 className="fw-300 text-2x mt-2">20</h2>
            </div>
            <div className="col">
              <small className="text-gray-500">In progress</small>
              <h2 className="fw-300 text-2x mt-2">20</h2>
            </div>
            <div className="col">
              <small className="text-gray-500">In review</small>
              <h2 className="fw-300 text-2x mt-2">20</h2>
            </div>
            <div className="col">
              <small className="text-gray-500">Completed</small>
              <h2 className="fw-300 text-2x mt-2">20</h2>
            </div>
          </div>
        </div>
        {/*  */}

        <div className="col-4 col-offset-2">
          <RiskSlider />
        </div>
      </div>


    </div>
  );
}
